import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { providerAssignmentActions } from '../../../../../../store';
import { toClientOptions } from './utils';

import type { AppDispatch, RootState } from '../../../../../../store';

export function useQuestionnaireClientOptions(providerId: number) {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { practicingGuardianAssignments, practicingGuardianAssignmentsLoading } = useSelector(
    (state: RootState) => state.providerAssignment,
  );

  useEffect(() => {
    dispatch(providerAssignmentActions.clearPracticingGuardianAssignments());

    const request = dispatch(
      providerAssignmentActions.getPracticingGuardianAssignments({
        providerId,
        getAccessTokenSilently,
      }),
    );

    return () => {
      request.abort();
      dispatch(providerAssignmentActions.clearPracticingGuardianAssignments());
    };
  }, [dispatch, getAccessTokenSilently, providerId]);

  return {
    clientOptions: practicingGuardianAssignmentsLoading
      ? []
      : toClientOptions(practicingGuardianAssignments ?? []),
    loading: practicingGuardianAssignmentsLoading,
  };
}
